import {BaseApp, DIALOG_FLAG_DISABLE_BACKDROP_CLICK, DIALOG_FLAG_SHOW_CLOSE} from "../../../../shared/BaseApp";
import React from "react";
import {ImportsFragment} from "./ImportsFragment";
import {
  DialogFragment,
  PageFragment,
  PageFragmentProps,
  PageFragmentState,
  PageFragmentStyleFlags
} from "@/shared/PageFragment";
import {LabelerImport} from "@/fyneai-shared/types";
import {PAGE_FRAGMENT_XLG_WIDTH} from "@/shared/dimens";
import {TableDataContainerMultiSelectListener} from "@/shared/TableDataContainer";

export class SelectImportHelper {

  static selectImport(datasetId: string, initialSelection: LabelerImport[], onSelectionChanged: (items: LabelerImport[]) => void): void {
    const id = BaseApp.CONTEXT.showDialog(
      {flags: DIALOG_FLAG_SHOW_CLOSE | DIALOG_FLAG_DISABLE_BACKDROP_CLICK},
      () => <SelectLabelerImportFragment
        datasetId={datasetId}
        initialSelection={initialSelection}
        onSelectionChanged={(items: LabelerImport[]) => {
          BaseApp.CONTEXT.hideDialog(id);
          onSelectionChanged(items);
        }}
      />);
  }
}

type SelectLabelerImportFragmentProps = PageFragmentProps & {
  datasetId: string,
  initialSelection?: LabelerImport[],
  onSelectionChanged: (items: LabelerImport[]) => void,
}

type SelectLabelerImportFragmentState = PageFragmentState & {
  selection: LabelerImport[],
}

class SelectLabelerImportFragment extends DialogFragment<SelectLabelerImportFragmentProps, SelectLabelerImportFragmentState> implements TableDataContainerMultiSelectListener<LabelerImport> {

  protected onCreateState(props?: SelectLabelerImportFragmentProps): SelectLabelerImportFragmentState {
    return {
      ...super.onCreateState(props),
      selection: props.initialSelection || [],
    };
  }

  protected styleFlags(): number | PageFragmentStyleFlags {
    return PageFragment.STYLE_ACTION_PANEL_TYPE_BUTTON_FLAG;
  }

  protected getActionButtonText(): string {
    return "Select";
  }

  onActionButtonClicked(event?): Promise<boolean> | void {
    this.props.onSelectionChanged(this.state.selection);
  }

  onSelectionChanged(items: LabelerImport[], exitSelection: () => void): void {
    this.setState({
      selection: items,
    });
  }

  renderContent(): React.ReactElement {
    return <div style={{
      display: "flex",
      flexDirection: "column",
      width: "92dvw",
      height: "84dvh"
    }}>
      <ImportsFragment
        datasetId={this.props.datasetId}
        tableMultiSelectListener={this}
        tableSelectModeConfig={{
          initialSelection: this.props.initialSelection,
        }}/>
    </div>;
  }
}
